interface IProductDescriptionSource {
  description?: unknown;
  descriptionJson?: unknown;
  seoDescription?: unknown;
}

const normalizeWhitespace = (value: string) =>
  value.replace(/\s+/g, " ").trim();

const readDescriptionJson = (value: unknown): string => {
  if (!value) {
    return "";
  }

  try {
    const document = typeof value === "string" ? JSON.parse(value) : value;
    if (!document || !Array.isArray(document.blocks)) {
      return "";
    }

    return normalizeWhitespace(
      document.blocks
        .map(block =>
          block && typeof block.text === "string" ? block.text : ""
        )
        .filter(Boolean)
        .join(" ")
    );
  } catch (_error) {
    return "";
  }
};

export const getProductDescription = (
  product: IProductDescriptionSource
): string => {
  if (typeof product.seoDescription === "string") {
    const seoDescription = normalizeWhitespace(product.seoDescription);
    if (seoDescription) {
      return seoDescription;
    }
  }

  const richTextDescription = readDescriptionJson(product.descriptionJson);
  if (richTextDescription) {
    return richTextDescription;
  }

  return typeof product.description === "string"
    ? normalizeWhitespace(product.description)
    : "";
};

export const getProductMetaDescription = (
  product: IProductDescriptionSource,
  maxLength = 160
): string => {
  const description = getProductDescription(product);
  if (description.length <= maxLength) {
    return description;
  }

  const availableText = description.slice(0, Math.max(0, maxLength - 1));
  const lastWordBoundary = availableText.lastIndexOf(" ");
  const cutoff =
    lastWordBoundary >= Math.floor(maxLength * 0.6)
      ? lastWordBoundary
      : availableText.length;

  return `${availableText.slice(0, cutoff).trim()}…`;
};
